import axios from "axios";
import { useEffect, useState } from "react";
import Carousel from "react-multi-carousel";
import API_URL from "../../constant/api.config";

import "react-multi-carousel/lib/styles.css";
import MediumPopup from "../MediumPopup";
// import ButtonAdminpanel from "../ButtonAdminpanel";
import { Link } from "react-router-dom";
import { useAuth } from "../../AuthProvider";
import axiosInstance from "@/axiosHttp";
import defaultValues from "../../constant/defaultValues";
import roles from "@/constant/roles.config";
import { buildPath, setAuthHeaders } from "@/utils/common";
import { privateRoutePaths } from "@/routes/private.route.config";

import basic from "@/assets/images/webp/basic.webp";
import elite from "@/assets/images/webp/elite.webp";
import plus from "@/assets/images/webp/plus.webp";
import pro from "@/assets/images/webp/Pro-Partner.webp";

const PromotionMedias = (props) => {
  const [mediummodalShow, setMediumModalShow] = useState(false);
  const { user, isPreKYCUser, isDemoUser, isEndUser, isViewer } = useAuth();

  const [pmedia, setPMedia] = useState([]);
  const industries = defaultValues.DUMMY_INDUSTRIES;
  const production_id = "326271";
  const local_id = "2668";
  const uat_id = "15182";
  const dev_id = "11492";
  let logistic_company_id = "";

  if (defaultValues.SERVER_TYPE === "local") {
    logistic_company_id = local_id;
  } else if (defaultValues.SERVER_TYPE === "dev") {
    logistic_company_id = dev_id;
  } else if (defaultValues.SERVER_TYPE === "uat") {
    logistic_company_id = uat_id;
  } else if (defaultValues.SERVER_TYPE === "production") {
    logistic_company_id = production_id;
  }

  const getPromotionMedias = async () => {

    const headers = setAuthHeaders();

    await axiosInstance
      .get(API_URL + "/promotion-media-details", {
        headers
      })
      .then((response) => {
        if (response.status === 200) {
          if (response.data.status === true) {
            //setSliderAll(response.data.data);
            setPMedia(response.data.data);
          }
        }
      })
      .catch((err) => {
        console.log("Error ========== ", err);
      });
  };

  useEffect(() => {
    getPromotionMedias();
  }, []);

  const getPrefix = () => {
    if (user && isPreKYCUser) return roles.PRE_KYC.prefix;
    if (user && isDemoUser) return roles.DEMO.prefix;
    if (user && isEndUser) return roles.END_USER.prefix;
    if (user && isViewer) return roles.VIEWER.prefix;
    return roles.SUPER_ADMIN.prefix;
  };

  return (
    <div className="new-design">
      <div className="card-header  d-flex justify-content-between">
        <h3>{props.title}</h3>
        {user &&
          isDemoUser && (
            <button
              className=" btn btn-light border preview-profile-btn btn"
              onClick={() => {
                setMediumModalShow(true);
              }}
            >
              {" "}
              Our Industries
            </button>
          )}
      </div>

      <div className="dashboart-chart-banner">
        <Carousel
          additionalTransfrom={0}
          arrows={true}
          autoPlaySpeed={3000}
          autoPlay={true}
          centerMode={false}
          //className="pl-1 pr-1"
          containerClass="dashboard-banners"
          dotListClass=""
          draggable={true}
          focusOnSelect={false}
          infinite
          itemClass=""
          keyBoardControl
          minimumTouchDrag={80}
          pauseOnHover
          renderArrowsWhenDisabled={true}
          renderButtonGroupOutside={false}
          renderDotsOutside={false}
          responsive={{
            desktop: {
              breakpoint: {
                max: 3000,
                min: 1024,
              },
              items: 1,
            },
            mobile: {
              breakpoint: {
                max: 464,
                min: 0,
              },
              items: 1,
            },
            tablet: {
              breakpoint: {
                max: 1024,
                min: 464,
              },
              items: 1,
            },
          }}
          rewind={true}
          rewindWithAnimation={true}
          rtl={false}
          shouldResetAutoplay
          showDots={false}
          sliderClass=""
          slidesToSlide={1}
          swipeable
        >
          {pmedia &&
            pmedia.map((val) => {
              let normalizedUrl = "";
              if (val.url) {
                const isExternal = !val.url.startsWith("/");

                normalizedUrl = isExternal
                  ? val.url.startsWith("http")
                    ? val.url
                    : `https://${val.url}`
                  : val.url;
              }


              return (
                <>
                  <div>
                    <div className="promotion-img-wrape">
                      <a
                        href={`/${getPrefix()}${buildPath(privateRoutePaths.VIEW_COMPANY_PROFILE, { id: val?.member_id })}`}
                        key={`link-${val.id}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img
                          src={`${val.image}`}
                          key={val.id}
                          style={{ maxWidth: "100%", height: "auto" }}
                          alt=""
                        />{" "}
                      </a>
                    </div>
                    <div className="text-slider-wrape">
                      <div className="bedge-wrape">
                        {val.badge === 'Basic' ? (
                          <img src={basic} alt="Basic" loading="lazy" />
                        ) : val.badge === 'Pro' ? (
                          <img src={pro} alt="Pro" loading="lazy" />
                        ) : val.badge === 'Plus' ? (
                          <img src={plus} alt="Plus" loading="lazy" />
                        ) : val.badge === 'Elite' ? (
                          <img src={elite} alt="Elite" loading="lazy" />
                        ) : (
                          <img src={basic} alt="badge" loading="lazy" />
                        )}
                      </div>
                      <div className="content-wrape">
                        <h3>{val.companyName || val.company_name}</h3>
                        <div className="contact-detail">
                          <div className="left">
                            {

                              val.url && <div className="">
                                <a href={normalizedUrl} title={normalizedUrl} target="_blank" rel="noreferrer" >
                                  <i className="icon web"></i>
                                  {val.url}
                                </a>
                              </div>
                            }

                            {
                              val.email && <p>
                                <a href={`mailto:${val.email}`} title={val.email}>
                                  <i className="icon mail"></i> {val.email}
                                </a>
                              </p>
                            }
                          </div>
                          <div className="right">
                            <p>
                              <b>Orex ID: </b>
                              {[val.member_unique_number]}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </>
              );
            })}
        </Carousel>
      </div>

      <MediumPopup
        title={"Industries"}
        mediummodalShow={mediummodalShow}
        setMediumModalShow={setMediumModalShow}
      //    closeButtonLabel="Cancel"
      //    okButtonLabel="Submit"
      //    onSubmit={handleInquirySubmit}
      >
        <div className="demo-product">
          {industries &&
            industries.map((industry) => {
              let company_id = null;
              if (defaultValues.SERVER_TYPE === "local") {
                company_id = industry.localId;
              } else if (defaultValues.SERVER_TYPE === "dev") {
                company_id = industry.devId;
              } else if (defaultValues.SERVER_TYPE === "uat") {
                company_id = industry.uatId;
              } else if (defaultValues.SERVER_TYPE === "production") {
                company_id = industry.productionId;
              }
              return (
                <>
                  {industry.industry_name !== "Others" ? (
                    <Link to={`/${getPrefix()}${buildPath(privateRoutePaths.VIEW_COMPANY_PROFILE, { id: company_id })}`} target="_blank" >
                      <button
                        type="button"
                        className={`btn btn-primary- small ${industry.className}`}
                      >
                        {industry.industry_name}
                      </button>
                      {/* <ButtonAdminpanel className={industry.className}>
                        {industry.industry_name}
                      </ButtonAdminpanel> */}
                    </Link>
                  ) : null}
                </>
              );
            })}
          <Link to={`/${getPrefix()}${buildPath(privateRoutePaths.VIEW_COMPANY_PROFILE, { id: logistic_company_id })}`} target="_blank">
            {/* <ButtonAdminpanel className="btn-regi pro-agri Vivid_yellow">
              Logistic partner{" "}
            </ButtonAdminpanel> */}
            <button
              type="button"
              className={`btn btn-primary- btn-regi small Vivid_yellow`}
            >
              Logistic partner{" "}
            </button>
          </Link>
        </div>
      </MediumPopup>
    </div>
  );
};

export default PromotionMedias;
